import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, TextInput, Colors } from 'advenio-components'
import { Form } from 'formsy-react-2'
import DocumentsActions from '../../../Data/Redux/DocumentsRedux'

var Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

var SearchRow = styled.div`
  display: inline-flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 16px;
`

var InputWrapper = styled.div`
  width: 300px;
`

var Counter = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${Colors.blue500};
  margin-bottom: 12px;
`

var SelectAllRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #F5F6FA;
  border-radius: 4px;
`

var Checkbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

var CheckboxLabel = styled.label`
  font-size: 14px;
  color: #212B36;
  cursor: pointer;
`

var DocumentList = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 320px;
  border: 1px solid ${Colors.gray200};
  border-radius: 4px;
`

var DocumentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid ${Colors.gray200};
  cursor: pointer;
  background: ${function (props) { return props.selected ? '#E3F2FD' : '#FFFFFF' }};
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: ${function (props) { return props.selected ? '#BBDEFB' : '#F5F6FA' }};
  }
`

var DocInfo = styled.div`
  flex: 1;
`

var DocName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #212B36;
`

var DocMeta = styled.div`
  font-size: 12px;
  color: #637381;
  margin-top: 2px;
`

var NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  color: #637381;
  font-size: 14px;
`

class Step1SelectDocuments extends Component {
  constructor (props) {
    super(props)
    this.state = {
      search: ''
    }
  }

  componentDidMount () {
    this.props.fetchDocuments({})
  }

  handleSearch = (formData) => {
    var search = formData.search || ''
    this.setState({ search: search })
    var filters = {}
    if (search) {
      filters.search = search
    }
    this.props.fetchDocuments(filters)
  }

  isSelected = (docId) => {
    var selected = this.props.selectedDocuments
    for (var i = 0; i < selected.length; i++) {
      if (selected[i].id === docId) return true
    }
    return false
  }

  handleToggleDocument = (doc) => {
    if (this.isSelected(doc.id)) {
      this.props.deselectDocument(doc.id)
    } else {
      this.props.selectDocument(doc)
    }
  }

  handleSelectAll = () => {
    var documents = this.props.documents
    var selectedDocuments = this.props.selectedDocuments

    if (selectedDocuments.length === documents.length && documents.length > 0) {
      this.props.clearDocuments()
    } else {
      this.props.selectAllDocuments(documents)
    }
  }

  formatMimeType = (mime) => {
    if (!mime) return '-'
    if (mime === 'application/pdf') return 'PDF'
    if (mime.indexOf('word') > -1) return 'Word'
    if (mime.indexOf('excel') > -1 || mime.indexOf('spreadsheet') > -1) return 'Excel'
    if (mime.indexOf('powerpoint') > -1 || mime.indexOf('presentation') > -1) return 'PowerPoint'
    if (mime.indexOf('image') > -1) return 'Imagen'
    if (mime === 'text/plain') return 'Texto'
    return mime
  }

  render () {
    var documents = this.props.documents
    var selectedDocuments = this.props.selectedDocuments
    var fetching = this.props.fetching
    var self = this

    var allSelected = documents.length > 0 && selectedDocuments.length === documents.length

    return (
      <Container>
        <SearchRow>
          <Form onSubmit={this.handleSearch}>
            <div style={{ display: 'inline-flex', alignItems: 'flex-end', gap: '8px' }}>
              <InputWrapper>
                <TextInput
                  name='search'
                  label='Buscar documento'
                  value={this.state.search}
                />
              </InputWrapper>
              <Button primary small type='submit' loading={fetching}>
                Buscar
              </Button>
            </div>
          </Form>
        </SearchRow>

        <Counter>
          {selectedDocuments.length + ' documento' + (selectedDocuments.length !== 1 ? 's' : '') + ' seleccionado' + (selectedDocuments.length !== 1 ? 's' : '')}
        </Counter>

        <SelectAllRow>
          <Checkbox
            type='checkbox'
            checked={allSelected}
            onChange={this.handleSelectAll}
            id='select-all-docs'
          />
          <CheckboxLabel htmlFor='select-all-docs'>Seleccionar todos</CheckboxLabel>
        </SelectAllRow>

        <DocumentList>
          {fetching && <NoResults>Cargando documentos...</NoResults>}
          {!fetching && documents.length === 0 && (
            <NoResults>No se encontraron documentos</NoResults>
          )}
          {!fetching && documents.map(function (doc) {
            var selected = self.isSelected(doc.id)
            return (
              <DocumentItem
                key={doc.id}
                selected={selected}
                onClick={function () { self.handleToggleDocument(doc) }}
              >
                <Checkbox
                  type='checkbox'
                  checked={selected}
                  onChange={function () {}}
                />
                <DocInfo>
                  <DocName>{doc.name}</DocName>
                  <DocMeta>
                    {self.formatMimeType(doc.mime_type)}
                    {doc.version_count ? ' · v' + doc.version_count : ''}
                  </DocMeta>
                </DocInfo>
              </DocumentItem>
            )
          })}
        </DocumentList>
      </Container>
    )
  }
}

Step1SelectDocuments.propTypes = {
  documents: PropTypes.array,
  selectedDocuments: PropTypes.array,
  fetching: PropTypes.bool,
  fetchDocuments: PropTypes.func.isRequired,
  selectDocument: PropTypes.func.isRequired,
  deselectDocument: PropTypes.func.isRequired,
  selectAllDocuments: PropTypes.func.isRequired,
  clearDocuments: PropTypes.func.isRequired
}

Step1SelectDocuments.defaultProps = {
  documents: [],
  selectedDocuments: [],
  fetching: false
}

var mapStateToProps = function (state) {
  return {
    documents: state.documents.library.documents,
    selectedDocuments: state.documents.wizard.selectedDocuments,
    fetching: state.documents.library.fetching
  }
}

var mapDispatchToProps = function (dispatch) {
  return {
    fetchDocuments: function (filters) {
      return dispatch(DocumentsActions.fetchDocumentsRequest(filters))
    },
    selectDocument: function (doc) {
      return dispatch(DocumentsActions.selectDocument(doc))
    },
    deselectDocument: function (docId) {
      return dispatch(DocumentsActions.deselectDocument(docId))
    },
    selectAllDocuments: function (docs) {
      return dispatch(DocumentsActions.selectAllDocuments(docs))
    },
    clearDocuments: function () {
      return dispatch(DocumentsActions.clearDocuments())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step1SelectDocuments)



// WEBPACK FOOTER //
// ./src/Containers/Documents/DistributeWizard/Step1SelectDocuments.jsx